import { TRoute } from "@/types";

import { Clients, Companies, Profile, Subscription } from "@/views";
import { WorkspaceMembers } from "@/views/Workspace/WorkspaceMembers";

export const ProfileMenuRoutesBase: TRoute[] = [
	{
		name: "Profile",
		path: ["/profile"],
		title: "Profile",
		picto: "user",
		element: Profile,
	},
	{
		name: "Subscription",
		title: "Subscription",
		path: ["/subscription"],
		picto: "tag",
		element: Subscription,
	},
	{
		name: "Workspace",
		title: "Workspace",
		path: ["/workspace"],
		picto: "users",
		element: WorkspaceMembers,
		feature: "sharing",
	},
	{
		name: "Companies",
		title: "Companies",
		path: ["/companies"],
		picto: "briefcase",
		element: Companies,
	},
	{
		name: "Clients",
		title: "Clients",
		path: ["/clients"],
		picto: "target",
		element: Clients,
	},
];
